'use client';
import { useCallback } from 'react';
import posthog from 'posthog-js';

export interface AnalyticsEvent {
  eventName: string;
  properties?: Record<string, any>;
  userId?: string;
  distinctId?: string;
}

export interface UseAnalyticsReturn {
  track: (event: AnalyticsEvent) => void;
  capture: (eventName: string, properties?: Record<string, any>) => void;
  identify: (userId: string, properties?: Record<string, any>) => void;
}

export const useAnalytics = (): UseAnalyticsReturn => {
  const track = useCallback((event: AnalyticsEvent) => {
    const eventData = {
      ...event.properties,
      timestamp: Date.now(),
      ...(event.userId && { user_id: event.userId }),
    };

    posthog.capture(event.eventName, eventData);
  }, []);

  const capture = useCallback((eventName: string, properties?: Record<string, any>) => {
    const eventData = {
      ...properties,
      timestamp: Date.now(),
    };

    posthog.capture(eventName, eventData);
  }, []);

  const identify = useCallback((userId: string, properties?: Record<string, any>) => {
    posthog.identify(userId, properties);
  }, []);

  return {
    track,
    capture,
    identify,
  };
};
